// Front-end "middleware" for sending people away from logged-in / admin routes;
// actual auth status tracked in platfrom-api/app/dependencies/auth.py

import { Navigate } from 'react-router-dom'
import { useWalletContext } from '@/contexts/WalletContext'

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { walletAddress, isSessionValid } = useWalletContext()

    if (!walletAddress || !isSessionValid) {
        return <Navigate to="/" replace />
    }

    return <>{children}</>
}